module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-box"
  }, [_c('header', {
    staticClass: "w"
  }, [_c('div', {
    staticClass: "w-box"
  }, [_c('div', [_c('h1', {
    on: {
      "click": function($event) {
        return _vm.changePage(-1)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "title": "净空老法师專集"
    }
  }, [_vm._v("净空老法师專集")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "right-box"
  }, [_c('div', {
    staticClass: "nav-list"
  }, [_c('a', {
    attrs: {
      "href": "/blog/archives/211",
      "target": "_self"
    }
  }, [_vm._v("App下載")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.chinkung.org/",
      "target": "_self"
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "placeholder": "淨空老法師圖文檢索中心",
      "size": "small",
      "maxlength": "20"
    },
    on: {
      "change": _vm.searchBlur
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.searchBtn
    },
    slot: "append"
  })], 1)], 1)])])]), _vm._v(" "), _vm._t("nav", function() {
    return [_c('div', {
      staticClass: "nav-sub",
      class: {
        fixed: _vm.st
      }
    }, [_c('el-row', [_c('el-col', {
      staticClass: "mymenu",
      attrs: {
        "push": 1,
        "xs": 23,
        "sm": 23,
        "md": 20,
        "lg": 16,
        "xl": 14
      }
    }, [_c('div', {
      staticClass: "w"
    }, [_c('i', {
      staticClass: "iconfont icon-menu",
      style: (_vm.mbMenu),
      on: {
        "click": function($event) {
          _vm.drawer = !_vm.drawer
        }
      }
    }), _vm._v(" "), _c('el-menu', {
      staticClass: "head-el-menu",
      style: (_vm.wdMenu),
      attrs: {
        "default-active": _vm.$route.name,
        "background-color": "#dcf0f4",
        "text-color": "#000000",
        "active-text-color": "#409EFF",
        "router": "",
        "mode": "horizontal"
      },
      on: {
        "select": _vm.handleSelect
      }
    }, [_c('el-submenu', {
      attrs: {
        "index": "home"
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('a', {
      attrs: {
        "href": "/",
        "target": "_self"
      }
    }, [_vm._v("首頁")])]), _vm._v(" "), _c('el-menu-item', {
      key: "https://www.amtb.tw/",
      attrs: {
        "index": "https://www.amtb.tw/"
      }
    }, [_vm._v("專集網站\n                  ")]), _vm._v(" "), _c('el-menu-item', {
      key: "https://www.amtb.cn/",
      attrs: {
        "index": "https://www.amtb.cn/"
      }
    }, [_vm._v("大陸站\n                  ")]), _vm._v(" "), _c('el-menu-item', {
      key: "https://www.chinkung.org",
      attrs: {
        "index": "https://www.chinkung.org"
      }
    }, [_vm._v("English\n                  ")])], 2), _vm._v(" "), _c('el-menu-item', {
      attrs: {
        "index": "livetv"
      }
    }, [_vm._v("直播台")]), _vm._v(" "), _c('el-menu-item', {
      attrs: {
        "index": "lectureroom"
      }
    }, [_vm._v("影音報恩講堂")]), _vm._v(" "), _c('el-menu-item', {
      attrs: {
        "index": "ebooklist"
      }
    }, [_vm._v("講記著作")]), _vm._v(" "), _c('el-submenu', {
      attrs: {
        "index": "4"
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v("墨寶卡片")]), _vm._v(" "), _c('el-menu-item', {
      attrs: {
        "index": "moIndex"
      }
    }, [_vm._v("墨寶")]), _vm._v(" "), _c('el-menu-item', {
      attrs: {
        "index": "deskIndex"
      }
    }, [_vm._v("卡片")])], 2), _vm._v(" "), _c('el-menu-item', {
      attrs: {
        "index": "5"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "#000000"
      },
      attrs: {
        "href": "/blog/",
        "target": "_self"
      }
    }, [_vm._v("法音宣流")])]), _vm._v(" "), _c('el-menu-item', {
      attrs: {
        "index": "6"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "#000000"
      },
      attrs: {
        "href": "/blog/archives/4416",
        "target": "_self"
      }
    }, [_vm._v("世界淨宗")])])], 1)], 1)])], 1)], 1)]
  }), _vm._v(" "), _c('el-drawer', {
    staticClass: "left-drawer",
    attrs: {
      "title": "關閉",
      "size": "75%",
      "visible": _vm.drawer,
      "direction": _vm.direction,
      "with-header": true,
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.drawer = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-info"
  }), _vm._v("關閉")]), _vm._v(" "), _c('div', {
    staticClass: "left-scroll"
  }, [_c('el-menu', {
    staticClass: "left-el-menu",
    attrs: {
      "background-color": "#fafafa",
      "unique-opened": true,
      "text-color": "#000000",
      "active-text-color": "#409EFF",
      "router": "",
      "mode": "vertical"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-submenu', {
    staticClass: "head-sub-menu",
    attrs: {
      "index": "home"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('a', {
    attrs: {
      "href": "/",
      "target": "_self"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('el-menu-item', {
    key: "https://www.amtb.tw/",
    attrs: {
      "index": "https://www.amtb.tw/"
    }
  }, [_vm._v("專集網站\n        ")]), _vm._v(" "), _c('el-menu-item', {
    key: "https://www.amtb.cn/",
    attrs: {
      "index": "https://www.amtb.cn/"
    }
  }, [_vm._v("大陸站\n        ")]), _vm._v(" "), _c('el-menu-item', {
    key: "https://www.chinkung.org",
    attrs: {
      "index": "https://www.chinkung.org"
    }
  }, [_vm._v("English\n        ")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "livetv"
    },
    on: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_vm._v("直播台")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "lectureroom"
    },
    on: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_vm._v("影音報恩講堂")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "ebooklist"
    },
    on: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_vm._v("講記著作")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "4"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("墨寶卡片")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "moIndex"
    },
    on: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_vm._v("墨寶")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "deskIndex"
    },
    on: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_vm._v("卡片")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "5"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#000000"
    },
    attrs: {
      "href": "/blog/",
      "target": "_self"
    }
  }, [_vm._v("法音宣流")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "6"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#000000"
    },
    attrs: {
      "href": "/blog/archives/4416",
      "target": "_self"
    }
  }, [_vm._v("世界淨宗")])])], 1)], 1)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20e5c2e4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/header.vue
// module id = 1053
// module chunks = 3